import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatRelativeDate(iso: string | null) {
  if (!iso) return "尚未联系";
  const value = new Date(iso);
  const today = new Date();
  const dayMs = 86_400_000;
  const days = Math.floor((today.getTime() - value.getTime()) / dayMs);
  if (days <= 0) return "今天";
  if (days === 1) return "昨天";
  if (days < 7) return `${days} 天前`;
  return new Intl.DateTimeFormat("zh-CN", { month: "short", day: "numeric" }).format(value);
}

export const stageLabels = {
  lead: "线索",
  discovery: "需求探索",
  evaluation: "方案评估",
  proposal: "方案确认",
  negotiation: "商务推进",
  closed_won: "已成交",
  closed_lost: "已结束"
} as const;

export const riskLabels = {
  low: "风险低",
  medium: "需关注",
  high: "高风险"
} as const;
